<template>
  <div class="int-pm" :class="{'int-pm-vertical': vertical}">
    <div class="pr-2 pl-2 int-pm" v-if="leftLabel">{{ leftLabel }}</div>
    <div class="int-pm-btn" :class="getBtnClass(true)"
         v-on:click="vertical ? increment() : decrement()">
      <slot :name="vertical ? 'increment' : 'decrement'">{{ vertical ? '+' : '-' }}</slot>
    </div>
    <div class="int-pm-value">
      <v-text-field v-model.number="intValue"
                    @click:clear="onClearInput()"
                    type="number"
                    clearable
                    class="pt-0 ma-0 trucks-input">
      </v-text-field>
    </div>
    <div class="int-pm-btn" :class="getBtnClass(false)"
         v-on:click="vertical ? decrement() : increment()">
      <slot :name="vertical ? 'decrement' : 'increment'">{{ vertical ? '-' : '+' }}</slot>
    </div>
    <div class="pl-2 int-pm" v-if="rightLabel">{{ rightLabel }}</div>
  </div>
</template>

<script>
export default {
  name: 'VTruckCounterField',
  props: {
    value: {
      default: 0,
      type: Number,
    },
    min: {
      default: 0,
      type: Number,
    },
    max: {
      default: undefined,
      type: Number,
    },
    step: {
      default: 1,
      type: Number,
    },
    vertical: {
      default: false,
      type: Boolean,
    },
    leftLabel: {
      type: String,
      default: null,
    },
    rightLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      intValue: 0,
    };
  },
  computed: {
    canIncrement() {
      return (this.max === undefined || ((this.intValue + this.step) <= this.max));
    },
    canDecrement() {
      return ((this.intValue - this.step) >= this.min);
    },
  },
  methods: {
    getBtnClass(firstBtn) {
      let btnClass = 'int-pm-';
      if ((firstBtn && !this.vertical) || (!firstBtn && this.vertical)) {
        btnClass += 'decrement';
        if (!this.canDecrement) btnClass += ' disabled';
      } else {
        btnClass += 'increment';
        if (!this.canIncrement) btnClass += ' disabled';
      }
      return btnClass;
    },
    increment() {
      if (this.canIncrement) {
        this.intValue = this.intValue + this.step;
        this.$emit('ipm-increment', this.intValue);
      }
    },
    decrement() {
      if (this.canDecrement) {
        this.intValue = this.intValue - this.step;
        this.$emit('ipm-decrement', this.intValue);
      }
    },
    onClearInput() {
      this.intValue = this.min;
      this.$emit('ipm-decrement', this.intValue);
    },
  },
  watch: {
    value() {
      this.intValue = this.value;
    },
    intValue() {
      this.$emit('input', this.intValue ? this.intValue : this.min);
    },
  },
  created() {
    this.intValue = this.value;
    if (this.step < 1) this.step = 1;
    if (this.max < this.min) this.max = undefined;
  },
};
</script>

<style>
  .trucks-input {
    width: 60px;
  }

  .trucks-input input::-webkit-outer-spin-button,
  .trucks-input input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .trucks-input input[type=number] {
    -moz-appearance:textfield;
  }

  .trucks-input .v-messages {
    display: none;
  }

  .trucks-input .input__slot {
    margin: 0;
  }
</style>

<style lang="css" scoped>

  .int-pm {
    display: table;
    text-align: center;
    position: relative;
  }
  .int-pm div {
    display: table-cell;
    vertical-align: middle;
  }
  .int-pm .int-pm-value {
    border-width: 1px 0;
    border-color: #ccc;
    border-style: solid;
    padding: 0 10px;
  }
  .int-pm .int-pm-btn {
    border: 1px solid #ccc;
    background-color: #ddd;
    cursor: pointer;
    padding: 5px 10px;
  }
  .int-pm .int-pm-btn:hover {
    background-color: #ccc;
  }
  .int-pm .int-pm-btn.disabled {
    background-color: #eee;
    color: #777;
    cursor: not-allowed;
  }
  .int-pm .int-pm-btn.disabled:hover {
    background-color: #eee;
  }
  .int-pm.int-pm-vertical {
    display: inline-block;
  }
  .int-pm.int-pm-vertical div {
    display: block;
  }
  .int-pm.int-pm-vertical .int-pm-value {
    border-width: 0 1px;
    padding: 5px 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/VTruckCounterField.vue